import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const InsiderEnrollmentBenefitsModalPage = lazy(
  () => import("../../pages/InsiderEnrollmentBenefitsModalPage")
);

export function EmilyChenRoutes() {
  return (
    <Switch>
      <Route
        path="/ec/insider-enrollment-benefits-modal"
        component={InsiderEnrollmentBenefitsModalPage}
      />
    </Switch>
  );
}

export const slug = "ec";
